<template>
  <v-row>
    <v-col sm="6" offset-sm="3" xs="12" class="settings-content">
      <section>
        <p class="pb-3">Gekoppeld voertuig</p>

        <template v-if="vehicle">
          <p class="pb-3 d-flex align-center justify-center ga-2">
            <span class="vehicle-name-badge">{{ vehicle.name }}</span>
            <span class="nl-license-plate">
              <span class="nl-license-plate-eu">NL</span>
              <span class="nl-license-plate-number">{{ vehicle.license_plate }}</span>
            </span>
          </p>
          <img
            v-if="vehicle.vehicle_type?.image_url"
            :src="vehicle.vehicle_type.image_url"
            class="mx-auto my-3 vehicle-image"
          />
          <v-table class="vehicle-details-table mx-auto mb-3" density="compact">
            <tbody>
              <tr>
                <th>Merk</th>
                <td>{{ vehicle.vehicle_type?.brand }}</td>
              </tr>
              <tr>
                <th>Model</th>
                <td>{{ vehicle.vehicle_type?.model }}</td>
              </tr>
              <tr>
                <th>Vestiging</th>
                <td>{{ vehicle.branch?.name }}</td>
              </tr>
              <tr>
                <th>Jaar</th>
                <td>{{ vehicle.year }}</td>
              </tr>
              <tr>
                <th>Brandstoftype</th>
                <td>{{ fuelTypeLabel(vehicle.fuel_type) }}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{{ statusLabel(vehicle.status) }}</td>
              </tr>
            </tbody>
          </v-table>
        </template>
        <template v-else>
          <p class="mb-4"><i>Er is nog geen voertuig gekoppeld.</i></p>
        </template>

        <p class="pb-3 d-flex justify-center ga-4">
          <VehicleLinkDialog :linkedVehicle="vehicle" />
          <v-btn v-if="vehicle" color="error" variant="outlined" @click="unlinkVehicle">
            Ontkoppelen
          </v-btn>
        </p>
      </section>
    </v-col>
  </v-row>
</template>

<script>
import VehicleLinkDialog from '@/components/VehicleLinkDialog'
import textMixin from '@/mixins/text'
import { refreshLinkedVehicle } from '@/utils/linkedVehicle'

export default {
  components: {
    VehicleLinkDialog,
  },
  mixins: [textMixin],
  computed: {
    vehicle() {
      return this.$store.getters.vehicle
    },
  },
  mounted() {
    this.$store.commit('app.setPageTitle', 'Instellingen')
    refreshLinkedVehicle()
  },
  methods: {
    fuelTypeLabel(fuelType) {
      if (!fuelType) {
        return fuelType
      }
      return this.text.vehicles.fuelTypes[fuelType.toLowerCase()] ?? fuelType
    },

    statusLabel(status) {
      if (!status) {
        return status
      }
      return this.text.vehicles.statuses[status] ?? status
    },

    unlinkVehicle() {
      if (!confirm('Weet je zeker dat je dit voertuig wilt ontkoppelen?')) {
        return
      }
      this.$store.commit('app.setVehicle', null)
    },
  },
}
</script>

<style scoped lang="scss">
.settings-content {
  text-align: center;
}
section {
  border-bottom: 1px solid #ddd;
  padding-top: 16px;
  &:last-of-type {
    border-bottom: none;
  }
}
.vehicle-details-table {
  max-width: 320px;
  :deep(tr) {
    border-bottom: none !important;
  }
  :deep(td), :deep(th) {
    height: auto !important;
    padding: 2px 0 !important;
    text-align: left;
  }
  :deep(th) {
    white-space: nowrap;
    padding-right: 16px !important;
  }
}
.vehicle-image {
  width: 450px;
  height: auto;
}
</style>
